















import { Vue, Component, Model, Emit } from "vue-property-decorator";
import cloneDeep from "lodash/cloneDeep";

interface DisplayCategory {
  text: string;
  isSelected: boolean;
}

@Component
export default class CategoriesPicker extends Vue {
  categories: DisplayCategory[] = [
    { text: "nu_gioi", isSelected: false },
    { text: "nam_gioi", isSelected: false },
    { text: "tuoi_18_24", isSelected: false },
    { text: "tuoi_25_34", isSelected: false },
    { text: "tuoi_35_44", isSelected: false },
    { text: "tuoi_45_54", isSelected: false },
    { text: "tuoi_55_64", isSelected: false },
    { text: "tuoi_65_74", isSelected: false },
    { text: "tuoi_tu_75", isSelected: false },
    { text: "da_dau", isSelected: false },
    { text: "da_kho", isSelected: false },
    { text: "da_hon_hop", isSelected: false },
    { text: "da_thuong", isSelected: false },
    { text: "nam_tan_nhang", isSelected: false },
    { text: "mun_viem", isSelected: false },
    { text: "da_nhay_cam", isSelected: false },
    { text: "bi_chung_do_mat", isSelected: false },
    { text: "none", isSelected: false }
  ];

  @Model("input", { type: Array, default: () => [] })
  selectedCategories!: string[];

  @Emit("input")
  emitInput(): string[] {
    const selectedCategories = this.categories.filter(
      category => category.isSelected === true
    );
    return selectedCategories.map(category => category.text);
  }

  mounted() {
    this.selectedCategories.forEach(category => {
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].text === category) {
          this.$set(this.categories[i], "isSelected", true);
          break;
        }
      }
    });
  }

  toggleState(event: Event, categoryIndex: number) {
    this.toggleCategoryLocally(categoryIndex);
    this.emitInput();
  }

  private toggleCategoryLocally(categoryIndex: number) {
    const targetCategory = cloneDeep(this.categories[categoryIndex]);
    targetCategory.isSelected = !targetCategory.isSelected;
    this.categories.splice(categoryIndex, 1, targetCategory);
  }
}
